import { connect } from 'react-redux';
import { default as DynamicPricingDashboardRoot } from './DynamicPricingDashboard';
import {
  getUserAirbnbListings,
  getListingPricingRecommendation,
} from 'src/store/Dashboard/actions';
import { getTokenThunk } from 'src/store/Auth/actions';

const mapStateToProps = ({ dashboard }) => ({
  user: dashboard.user,
  userAirbnbListings: dashboard.userAirbnbListings,
  listingPricingRecommendation: dashboard.listingPricingRecommendation,
});

export const DynamicPricingDashboard = connect(mapStateToProps)(DynamicPricingDashboardRoot);
